<template>
  <validation-provider
    #default="{ errors }"
    name="contractState"
    :rules="{
      required: requiredField,
    }"
  >
    <b-form-group
      label="Situação do Contrato"
      label-for="contractState"
    >
      <v-select
        id="contractState"
        v-model="contractState"
        :class="errors.length > 0 ? 'error-select' : ''"
        :options="contractStateOptions"
        :placeholder="'Situação do Contrato'"
        :disabled="readonly"
        :clearable="!readonly"
      >
        <template #option="{ label }">
          {{ label }}
        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  model: {
    prop: 'contractStateValue',
    event: 'contractStateChange',
  },
  props: {
    contractStateValue: {
      type: [Object, Boolean],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      contractStateOptions: [
        { label: 'Liberado', value: 'released' },
        { label: 'Suspenso', value: 'suspended' },
        { label: 'Pendente', value: 'draft' },
      ],
    }
  },
  computed: {
    contractState: {
      get() {
        return this.contractStateValue
      },
      set(value) {
        const valueMap = {
          released: { label: 'Liberado', value: 'released' },
          suspended: { label: 'Suspenso', value: 'suspended' },
          draft: { label: 'Pendente', value: 'draft' },
        }

        this.$emit('contractStateChange', valueMap[value] || value)
      },
    },
  },
  watch: {
    contractStateValue(newVal) {
      this.contractState = newVal
    },
  },
  created() {
    this.$emit('ready', true)
  },
}
</script>

<style lang="scss">

.v-select {
  background-color: white;
}
</style>
